//GSAPにScrollTriggerプラグイン登録
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

window.addEventListener('DOMContentLoaded', function(){

  //TOP ブラー（ A BETTER HIGH ）-----------------------------------------------
  const target = document.getElementById('js-better-high-content-text');
  const spans = target.querySelectorAll('span');
  //const maxBlur = 5;
  const maxBlur = 8;
  const total = spans.length;
  
  ScrollTrigger.create({
    trigger: target,
    start: "top center+=200",
    end: "top center+=-30",
    scrub: true,
    onUpdate: self => {
      let progress = Math.min(Math.max(self.progress, 0), 1);

      spans.forEach((span, i) => {
        let charThreshold = i / (total - 1);
        let denom = 1 - charThreshold;//分母

        let localProgress;
        if (denom === 0) {
          localProgress = progress >= 1 ? 1 : 0;
        } else {
          localProgress = (progress - charThreshold) / denom;
          localProgress = Math.min(Math.max(localProgress, 0), 1);
        }

        let blurValue = maxBlur * (1 - localProgress);
        span.style.filter = `blur(${blurValue}px)`;
      });
    }
  });

  /*---------------------------------------------*/
});


